import React, { useState, useEffect, useRef } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Button, Form, Input, Radio, message, Upload, Modal, Row, Col, ConfigProvider } from 'antd';
import defaultHeadImg from '@/assets/default.png'
import { getUser, request, setUser } from "@/utils";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.less";
import AliyunOSSUpload from "@/components/AliyunOssComponent";
import AliyunOSSUploadImg from "@/components/AliyunOssComponent/index2";
import defaultAvatar from '@/assets/default.png'
import Config from "@/config/config";
import { Func, rsaEncrypt } from "@/utils/func";
export default function UserInfoComponent(props) {
    const { title, type } = props
    const [countdown, setCountdown] = useState(60); // 初始倒计时值
    const [isCounting, setIsCounting] = useState(false); // 标志是否在倒计时中
    const [form] = Form.useForm(); // 创建表单实例
    const [info, setInfo] = useState({})
    const [isPwdModalOpen, setIsPwdModalOpen] = useState(false)
    const navigate = useNavigate()
    const [openEditName, setOpenEditName] = useState(false)
    const currentImg = useRef('')

    const onFinish = async (values) => {
        console.log('Received values of form: ', values);
        let pwd = await rsaEncrypt(values.password);
        const response = await request.post('auth/reset-pwd-web', {
            mobile: info.mobile,
            password: pwd,
            code: values.mobileCode,
        });
        if (response.code) {
            message.success(response.ret.cn)
        } else {
            message.success('密码修改成功')
            return setIsPwdModalOpen(false)
        }
    };
    const startCountdown = () => {
        setIsCounting(true);
        const interval = setInterval(() => {
            setCountdown((prevCount) => {
                if (prevCount <= 1) {
                    clearInterval(interval);
                    setIsCounting(false);
                    setCountdown(60)
                }
                return prevCount - 1;
            });
        }, 1000);
    };

    const handleSendCode = () => {
        try {
            console.log(form);
            let values = form.getFieldsValue();
            console.log(values);
            const phoneNumber = values.mobile;
            console.log(phoneNumber);
            // 手机号码验证，你可以根据实际需求修改验证规则
            if (/^1[3-9]\d{9}$/.test(phoneNumber)) {
                // 模拟发送验证码的异步操作，你需要替换成真实的 API 调用
                // 这里使用 setTimeout 模拟异步操作
                message.success('验证码已发送');
                startCountdown();
            } else {
                message.error('请输入有效的手机号码');
            }
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };


    const cancelModifyPwd = () => {
        setIsPwdModalOpen(false)
    }

    const confirmModifyPwd = async () => {

        // setIsPwdModalOpen(false)
    }

    const handleNickname = (e) => {

        if (e.target.value.length > 20) {
            e.target.value = e.target.value.slice(0, 20); // 截断超出长度的值
        }
        info.nickname = e.target.value
        setInfo({ ...info })
    }
    const modifyInfo = async (type) => {
        let params = {}
        if (type == 'nickname') {
            if (!info.nickname?.trim()) {
                message.error('请输入昵称');
                return;
            }
            if (info.nickname.length < 2) {
                message.error('昵称长度不能小于2个');
                return;
            }
            params.nickname = info.nickname
        } else if (type == 'email') {
            // 校验邮箱格式的正则表达式
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(info.email)) {
                message.error('请输入有效的邮箱地址');
                return;
            }
            params.email = info.email;
        } else if (type == 'avatar') {
            params.avatar = info.avatar || currentImg
        } else if (type == 'name_en') {
            if (!info.first_name?.trim() || !info?.last_name?.trim()) {
                message.error('请输入英文名');
                return;
            }
            if (info.first_name.length < 2 || info.last_name.length < 2) {
                message.error('英文姓和名的长度不能小于2个');
                return;
            }
            params.first_name = info.first_name
            params.last_name = info.last_name
        }
        try {
            const response = await request.post('auth/update-user', { id: info.id, ...params });
            if (response.code) {
                message.error(response.msg)
            } else {
                message.success('修改成功', 0.5, () => { window.location.reload() })
                let user = getUser()
                user[type] = info[type]
                console.log(user)
                setUser(user)
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    }

    const modifyAvatar = async (url) => {
        modifyInfo('avatar')
    }

    const modalStyles = {
        header: {
            borderRadius: 8,
            paddingInlineStart: 5,
        },
        body: {
            boxShadow: 'inset 0 0 5px #999',
            borderRadius: 5,
        },
        content: {
            borderRadius: 8,
        },
        footer: {
            borderTop: '1px solid #333',
        },

    };
    const imgUploadResult = (v) => {
        if (v[v.length - 1]['status'] === "done") {
            const imgUrl = v[v.length - 1]['url'];
            const ossPrefix = Config.imgPrefix;
            info.avatar = imgUrl
            setInfo({ ...info });
            currentImg.current = imgUrl
            modifyAvatar('avatar')
            console.log(v);
        }
    }

    const fetchData = async () => {
        try {
            const response = await request.get('auth/info'); // 使用封装好的Axios实例发送GET请求
            if (response.code) {
                message.error(response.msg)
            } else {
                setInfo(response.data)
                setUser(response.data)
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };
    const handleEditName = () => {
        modifyInfo('name_en')
        if ((info?.last_name?.trim() && info?.first_name?.trim()) && (info?.first_name?.length > 2 && info?.last_name?.length > 2)) {
            setOpenEditName(false)
        }

    }
    useEffect(() => {

        fetchData();
    }, [])


    return (
        <div className="userinfo-from">
            <div className="userinfo-title">
                {title}
            </div>
            <div className="userinfo-img">
                <img style={{ borderRadius: "50%" }} src={info.avatar ? Func.imgUrlFormat(info.avatar) : defaultAvatar} width="100%" height="100%" alt="" />
            </div>
            {/*<Upload showUploadList={false} {...props}>*/}
            {/*    <Button icon={<UploadOutlined/>} style={{marginLeft:"20px"}}>上传图片</Button>*/}
            {/*</Upload>*/}
            <div><AliyunOSSUpload onChange={imgUploadResult} type="avatar" /></div>
            <div className="userinfo-item-box">
                <div className="userinfo-label">
                    昵称:
                </div>
                <div className="userinfo-input">
                    <Input placeholder="请输入您的昵称" onChange={handleNickname} value={info.nickname} />
                    <Button onClick={() => { modifyInfo('nickname') }} style={{ border: '1px solid #C59D60', color: '#C59D60' }}>修改昵称</Button>
                </div>
                <div className="userinfo-label">
                    英文姓名:
                </div>
                <div className="userinfo-input">
                    <Input placeholder="还未设置" onChange={handleNickname}
                        disabled
                        style={{ color: info.last_name ? '#333' : '#999' }} value={info.last_name ? info.last_name + ' ' + info.first_name : ''} />
                    <Button onClick={() => { setOpenEditName(true) }} style={{ border: '1px solid #C59D60', color: '#C59D60' }}>修改姓名</Button>
                </div>
                {/* {info.mobile !== "" && */}
                <div>
                    <div className="userinfo-label">手机号码:</div>
                    <div className='userinfo-input'>
                        <Input placeholder="" value={info.mobile && '+' + (info.nation_code || '+86') + ' ' + info.mobile} disabled />
                        {
                            info.login_type == 0 ? <Button onClick={() => {
                                navigate('/bindPhone')
                            }} style={{ border: '1px solid #C59D60', color: "#C59D60" }}>修改号码</Button>
                                : <Button style={{ visibility: 'hidden' }} disabled>修改号码</Button>
                        }
                    </div>

                    <div className="userinfo-label">密码:</div>
                    <div className='userinfo-input'>
                        <Input placeholder="********" disabled /><Button
                            onClick={() => { navigate('/resetPwd') }}
                            style={{ border: '1px solid #C59D60', color: '#C59D60' }}>修改密码</Button>
                    </div>
                </div>
                {/* // } */}
                <div className="userinfo-label">
                    邮箱:
                </div>
                <div className="userinfo-input">
                    <Input placeholder={"还未设置"} value={info.email} onChange={(e) => {
                        info.email = e.target.value
                        setInfo({ ...info })
                    }}
                        style={{ color: info.last_name ? '#333' : '#999' }} />
                    <Button onClick={() => { modifyInfo('email') }} style={{ border: '1px solid #C59D60', color: '#C59D60' }}>修改邮箱</Button>
                </div>

            </div>
            <Modal
                title="修改姓名"
                open={openEditName}
                onOk={handleEditName}
                onCancel={() => {
                    setOpenEditName(false)
                    window.location.reload()
                }}
            >
                <div className='editName'>
                    <div className='editItem' style={{ marginRight: "20px" }}>
                        <div className='editLabel'>英文姓：</div>
                        <Input value={info.last_name} maxLength={20} placeholder='请输入英文姓' onInput={(e) => {
                            // 验证输入是否为英文和空格，若不是则截取符合规则的部分
                            const validValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                            info.last_name = validValue;
                            setInfo({ ...info });
                        }} />
                    </div>
                    <div className='editItem'>
                        <div className='editLabel'>英文名：</div>
                        <Input value={info.first_name} maxLength={20} placeholder='请输入英文名' onInput={(e) => {
                            const validValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                            info.first_name = validValue;
                            setInfo({ ...info });
                        }} />
                    </div>
                </div>
            </Modal>
            <ConfigProvider
                modal={{
                    styles: modalStyles,
                }}
            >
                <Modal
                    className="userinfo-modify-pwd-model"
                    title="修改密码"
                    open={isPwdModalOpen}
                    onOk={confirmModifyPwd} onCancel={cancelModifyPwd}
                    placement="bottom"
                    centered
                    width={460}
                    styles={modalStyles}
                    footer=""
                >
                    <div className="text-center">

                        <div className="forgetPassword-container">

                            <Form
                                layout='vertical'
                                initialValues={{
                                    checked: false,
                                }}
                                onFinish={onFinish}
                                validateTrigger={['onBlur']}
                                form={form}
                            >

                                <Form.Item
                                    label="手机号码"
                                >
                                    <Form.Item
                                        label="手机号码"
                                        noStyle
                                        name="mobile"
                                        initialValue={info.mobile}
                                    >

                                        <Input size="large" disabled />

                                    </Form.Item>
                                </Form.Item>

                                <Form.Item
                                    label="手机验证码"
                                >

                                    <Row gutter={20}>
                                        <Col span={16}>
                                            <Form.Item
                                                name="mobileCode"
                                                noStyle
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: '请输入手机验证码',
                                                    },
                                                ]}
                                                autoComplete="off"
                                            >
                                                <Input placeholder="请输入手机验证码" size="large" autoComplete="off" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Button
                                                className='sender-code'
                                                type="primary"
                                                size="large"
                                                onClick={handleSendCode}
                                                disabled={isCounting}
                                                style={{
                                                    backgroundColor: isCounting ? '#f9f5ef' : '',
                                                    color: isCounting ? '#C59D60' : '',
                                                    marginLeft: 0,
                                                    borderRadius: "4px",
                                                }}
                                            > {isCounting ? `${countdown}S后重发` : '发送验证码'}</Button>
                                        </Col>
                                    </Row>
                                </Form.Item>
                                <Form.Item label="新的密码">
                                    <Form.Item
                                        name="password"
                                        noStyle
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入密码',
                                            },
                                        ]} type="password">
                                        <Input.Password placeholder="请输入密码" size="large" />
                                    </Form.Item>
                                </Form.Item>
                                <div className='modify-pwd-hint'>
                                    密码8-18位，大/小写字母、数字和特殊字符中至少3种
                                </div>
                                <div>
                                    <Button onClick={cancelModifyPwd}
                                        style={{
                                            width: "120px",
                                            height: "40px",
                                            marginRight: "31px",
                                            marginBottom: "25px",
                                            fontSize: "14px",
                                            borderRadius: "4px",
                                        }}>取消</Button>
                                    <Button
                                        type="primary" htmlType="submit"
                                        style={{
                                            width: "120px",
                                            height: "40px",
                                            marginBottom: "25px",
                                            fontSize: "14px",
                                            borderRadius: "4px",
                                        }}>确定</Button>
                                </div>
                            </Form>
                        </div>

                    </div>
                </Modal>
            </ConfigProvider>
        </div>
    )
}
